"use client";
import {
  skeleton_default
} from "./chunk-SO5PHFDL.mjs";
import {
  useSkeleton
} from "./chunk-YENB4D5W.mjs";
export {
  skeleton_default as Skeleton,
  useSkeleton
};
